<template>
  <v-dialog
    v-model="value.show"
    @input="v => v || closeAction()"
    max-width="500px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
          value.mode === "edit"
            ? $t("editFaultMessage")
            : $t("createFaultMessage")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="editCreateForm">
          <v-container grid-list-sm>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field
                  name="name"
                  :label="$t('name')"
                  type="text"
                  v-model="faultMessage.name"
                  v-validate="'required|max:255'"
                  :data-vv-as="$t('name')"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="priority"
                  :label="$t('priority')"
                  type="number"
                  v-model="faultMessage.priority"
                  v-validate="'required|numeric'"
                  :data-vv-as="$t('priority')"
                  :error-messages="errors.collect('priority')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  name="bit_word"
                  :label="$t('bitWord')"
                  type="number"
                  v-model="faultMessage.bit_word"
                  v-validate="'required|numeric'"
                  :data-vv-as="$t('bitWord')"
                  :error-messages="errors.collect('bit_word')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  name="bit"
                  :label="$t('bit')"
                  type="number"
                  v-model="faultMessage.bit"
                  v-validate="'required|numeric'"
                  :data-vv-as="$t('bit')"
                  :error-messages="errors.collect('bit')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          flat
          @click.native="closeAction"
          :disabled="value.formDisabled"
          >{{ $t("close") }}</v-btn
        >
        <v-btn
          color="blue darken-1"
          flat
          @click.native="saveAction"
          :disabled="value.formDisabled"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  UPDATE_FAULT_MESSAGE,
  CREATE_FAULT_MESSAGE,
  RESET_FAULT_MESSAGE,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import validationErrorsMixin from "@/mixins/validationErrors.mixin";

export default {
  props: ["value"],
  data() {
    return {
      formDisabled: false
    };
  },
  computed: {
    ...mapGetters(["faultMessage"])
  },
  mixins: [validationErrorsMixin],
  methods: {
    saveAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.formDisabled = true;

          this.$store
            .dispatch(
              this.value.mode === "edit"
                ? UPDATE_FAULT_MESSAGE
                : CREATE_FAULT_MESSAGE,
              this.faultMessage
            )
            .then(() => {
              this.$store.dispatch(SHOW_SNACKBAR, {
                text: this.$t("savedSuccessfully", [this.$t("faultMessage")]),
                color: "success"
              });

              this.closeAction();
              this.$emit("saved");
            })
            .catch(() => {
              this.formDisabled = false;
            });
        }
      });
    },
    closeAction() {
      this.$emit("input", {
        mode: this.value.mode,
        show: false
      });
      this.formDisabled = false;
      // we need wait for animation until is finished
      setTimeout(() => {
        this.$store.dispatch(RESET_FAULT_MESSAGE);
        this.$refs.editCreateForm.reset();
        this.$validator.reset();
      }, 100);
    }
  }
};
</script>

<style scoped></style>
